/* Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const CSATStarSvg = () => (
  <svg width="1.5em" height="1.5em" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.86328 0L10.7717 5.87336L16.9473 5.87336L11.9511 9.50329L13.8595 15.3766L8.86328 11.7467L3.86711 15.3766L5.77548 9.50329L0.779301 5.87336L6.95491 5.87336L8.86328 0Z" fill="#FFCF24"/>
  </svg>
);

export const CSATStarIcon = props => <Icon component={CSATStarSvg} {...props} />;
